import { TFunction } from "i18next";
import { fetcher } from "src/services/config";
import { MethodType } from "src/services/type";
import { getQueryString } from "@utils/utilsApi";
import {
  formatDate,
  formatEnrollmentDate,
} from "@pages/Contents/V2/Corporate/Catalog/UsersAndGroups/config/enrollmentDates";
import { formatEnrollTypeLabel } from "@pages/Contents/V2/Corporate/Catalog/UsersAndGroups/config/enrollTypeMap";
import { normalizeEnrolledLo } from "./normalizeEnrolledLo";

const EXPORT_PAGE_SIZE = 100;

const readTotalPages = (metadata: any): number => {
  const value = Number(metadata?.total_pages ?? metadata?.totalPages);
  return Number.isFinite(value) && value > 0 ? value : 1;
};

const fetchAllGroupLos = async (
  url: string,
  loTitle?: string,
): Promise<any[]> => {
  const items: any[] = [];
  let pageIndex = 0;
  let totalPages = 1;
  do {
    const res = await fetcher(
      getQueryString(url, {
        pageIndex: String(pageIndex),
        pageSize: String(EXPORT_PAGE_SIZE),
        ...(loTitle ? { loTitle } : {}),
      }),
      MethodType.GET,
    );
    const output: any[] = res?.output || [];
    items.push(...output);
    totalPages = readTotalPages(res?.metadata);
    pageIndex += 1;
    if (output.length === 0) break;
  } while (pageIndex < totalPages);
  return items;
};

const escape = (value: any) => `"${String(value ?? "").replace(/"/g, '""')}"`;

export const downloadGroupLoCsv = async (
  url: string,
  groupId: string,
  t: TFunction,
  loTitle?: string,
) => {
  const rawItems = await fetchAllGroupLos(url, loTitle);

  const header = [
    t("learningObjects.csv.id"),
    t("learningObjects.csv.type"),
    t("learningObjects.csv.title"),
    t("learningObjects.csv.duration"),
    t("learningObjects.csv.enrollType"),
    t("learningObjects.csv.enrollDate"),
    t("learningObjects.csv.updateEnrollDate"),
    t("learningObjects.csv.expirationDate"),
    t("learningObjects.csv.expiryType"),
  ];

  const rows = rawItems.map((raw) => {
    const lo = normalizeEnrolledLo(raw);
    return [
      lo.id,
      lo.type,
      lo.title,
      lo.loDuration ?? lo.duration,
      formatEnrollTypeLabel(lo.enrollType),
      formatEnrollmentDate(lo.enrollDate),
      formatDate(lo.updateEnrollDate),
      formatDate(lo.expirationDate),
      lo.expiryType,
    ]
      .map(escape)
      .join(",");
  });

  const bom = "﻿";
  const sepDirective = "sep=,\r\n";
  const csvContent = `${bom}${sepDirective}${header
    .map(escape)
    .join(",")}\r\n${rows.join("\r\n")}\r\n`;

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = `group-${groupId}-learning-objects${
    loTitle ? "-filtered" : ""
  }.csv`;
  link.click();
  window.URL.revokeObjectURL(link.href);
};
